<template>
	<div class="main-contents">
		<!-- 로그인 폼 -->
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>404 NOT FOUND!!</span><br/>
					페이지를 확인 할 수 없습니다.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
	}
};
</script>